import React, { useState } from "react";
import AdminTabelHeader from "../../components/layout/header/AdminTabelHeader";
import { useParams,useNavigate } from "react-router-dom";
import "./socialmedia.css";
import { useMutation, useQuery } from "react-query";
import { BASEURL } from "../../../utils/BaseUrl";
import axios from "axios";
import SpinerLoading from "../../../common/Loading/SpinerLoading";
import Swal from "sweetalert2";
import TraingleLoading from "../../../common/Loading/TraingleLoading";
import ManditoryStar from "../../templates/ManditoryStar";

const SoacialmediaForm = () => {
  const [socialData, setSocialData] = useState({
    paltform: "",
    url: "",
    status: true,
  });

  const { id } = useParams();
  const navigate=useNavigate()

  const { data,isLoading } = useQuery({
    queryKey: "getsoacilMedia",
    queryFn: () =>
      axios.get(`${BASEURL}social-media/${id}`).then((res) => {
        return res?.data;
      }),
    onSuccess: (response) => {
      setSocialData({
        paltform: response?.link?.platform,
        url: response?.link?.url,
        status: response?.link?.status,
      });
    },
  });
  const updateMutation = useMutation({
    mutationFn: (values) => {
      return axios.put(`${BASEURL}social-media/${id}`, values);
    },
      onSuccess: () => {
          Swal.fire({
            title: "Social Media Updated Success",
            icon: "success",
            draggable: false,
            // confirmButtonColor:"#fcd70c",
            customClass: {
              confirmButton: "custom-confirm-button", // Add a custom class for styling
            },
          }).then(() => {
            navigate("/admin/socialmedia");
          });
        },
  });

  const handleChange = (e) => {
    const newData = { ...socialData };
    newData[e.target.name] = e.target.value;
    setSocialData(newData);
  };

  const handleSwitch = (e) => {

    setSocialData({
      ...socialData,
      status: e?.target?.checked,
    });
  };

  const handleUpdate = () => {
    const values = {
      platform: socialData?.paltform,
      url: socialData.url,
      status: socialData.status,
    };
    updateMutation.mutate(values);
  };
  return (
    <div>
      <AdminTabelHeader title={"Social Media"} btnStatus={false} />
      {updateMutation.isLoading && <TraingleLoading />}
      {
        isLoading && <TraingleLoading />
      }
      <div className="p-4">
        <div className="grid grid-cols-1 gap-4">
          <div>
          <ManditoryStar title={"Platform"} />

            <input
              name="paltform"
              className={`input`}
              type="text"
              placeholder="Enter your name"
              value={socialData.paltform}
              onChange={(e) => handleChange(e)}
            />
          </div>
          <div>
          <ManditoryStar title={"URL"} />

            <input
              name="url"
              className={`input`}
              type="text"
              placeholder="Enter your name"
              value={socialData.url}
              onChange={(e) => handleChange(e)}
            />
          </div>
          <div>
          <ManditoryStar title={"Status"} />

            <label class="toggle-switch">
              <input
                type="checkbox"
                onChange={(e) => handleSwitch(e)}
                checked={socialData.status}
              />
              <div class="toggle-switch-background">
                <div class="toggle-switch-handle"></div>
              </div>
            </label>
          </div>
        </div>
        <div className="flex justify-end my-4 ">
        <button
            onClick={() => navigate(-1)}
            // disabled={checkSubmit()}
            className={"formSubmit mr-8 cursor-pointer "}
          >
            Cancel
          </button>
          <button onClick={(e) => handleUpdate(e)} className={`formSubmit`}>
            Update
          </button>
        </div>
      </div>
    </div>
  );
};

export default SoacialmediaForm;
